import dynamic from 'next/dynamic'

import { Header } from '@fe-toolkit/web-components/ssr'
import { accountLinks } from '@fe-toolkit/utility'

import { useChromeFlags } from '@/layouts/Main/ChromeFlagsContext'

import { getLegacyHeaderLinks } from './legacyHeaderLinks'

const ACCOUNT_IMAGE_URL = 'https://giffgaff.com/styleguide/svg/gamification/avatar_default.svg'

// Loaded only when it renders, so Tamagui stays out of the main bundle.
const BrandRefreshHeader = dynamic(() =>
  import('@/components/brandRefresh/BrandRefreshChrome').then(m => m.BrandRefreshHeader),
)

// Full-nav degraded Header used when the fe_common remote is unavailable. Like fe-common's CommonHeader
// (and fe-modern-template's fallback), Brand Refresh picks the design system Header over the legacy one,
// and Black Friday or its pre-registration adds the Black Friday link to either. The flags come from the
// server render through context, not props.
//
// Shared by three consumers so the degraded UI is always identical:
//   - next/dynamic `loading` (shown while the remote chunk loads, and the server HTML)
//   - FederatedComponentBoundary fallback (remote loaded but threw in render)
//   - the errorLoadRemote registry (mfOfflineHandlingPlugin.js) — remote failed
//     to load; this is what makes a DOWN remote render a header at all, since
//     next/dynamic swallows a rejected loader and would otherwise render null.
export default function FallbackHeader({ username }: { username?: string }) {
  const { isBrandRefresh, isBlackFriday, isBlackFridayPrereg } = useChromeFlags()

  if (isBrandRefresh) return <BrandRefreshHeader username={username} />

  return (
    <Header
      account={true}
      accountImageUrl={ACCOUNT_IMAGE_URL}
      accountLinks={accountLinks}
      authUrlDashboard="/dashboard"
      authUrlLogIn="/auth/login"
      authUrlLogOut="/auth/logout"
      links={getLegacyHeaderLinks({ isBlackFriday, isBlackFridayPrereg })}
      position="sticky"
      username={username}
    />
  )
}
